/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateSampleExamDto
 */
export interface CreateUpdateSampleExamDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    sampleCollectId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    protocolNumber: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateSampleExamDto
     */
    sysNumber: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    fileNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    technicalSpecification: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    organizationTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    protocolPrintModeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    comments: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSampleExamDto
     */
    approved: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSampleExamDto
     */
    projectPOIiS: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    productTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    securedQuantity: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSampleExamDto
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    expirationText: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSampleExamDto
     */
    expirationNA: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSampleExamDto
     */
    supplyDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    supplierId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSampleExamDto
     */
    supplierNA: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSampleExamDto
     */
    supplierUnknown: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSampleExamDto
     */
    sampleSignatureDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    refusalReason: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    repairMethod: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    invoiceNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateSampleExamDto
     */
    invoiceNumberNA: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    reasonNotTakingControlSample: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    regulations: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateSampleExamDto
     */
    regulationIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    additionalInfo: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    findings: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSampleExamDto
     */
    completionDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    witnesses: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateSampleExamDto
     */
    collectDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSampleExamDto
     */
    euProjectTypeId: string;
}

export function CreateUpdateSampleExamDtoFromJSON(json: any): CreateUpdateSampleExamDto {
    return CreateUpdateSampleExamDtoFromJSONTyped(json, false);
}

export function CreateUpdateSampleExamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSampleExamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sampleCollectId': json['sampleCollectId'],
        'protocolNumber': json['protocolNumber'],
        'sysNumber': json['sysNumber'],
        'fileNumber': json['fileNumber'],
        'technicalSpecification': json['technicalSpecification'],
        'organizationTypeId': json['organizationTypeId'],
        'protocolPrintModeId': json['protocolPrintModeId'],
        'comments': json['comments'],
        'approved': json['approved'],
        'projectPOIiS': json['projectPOIiS'],
        'productTypeId': json['productTypeId'],
        'securedQuantity': json['securedQuantity'],
        'expirationDate': !exists(json, 'expirationDate') ? undefined : (json['expirationDate'] === null ? null : new Date(json['expirationDate'])),
        'expirationText': json['expirationText'],
        'expirationNA': json['expirationNA'],
        'supplyDate': !exists(json, 'supplyDate') ? undefined : (json['supplyDate'] === null ? null : new Date(json['supplyDate'])),
        'supplierId': json['supplierId'],
        'supplierNA': json['supplierNA'],
        'supplierUnknown': json['supplierUnknown'],
        'sampleSignatureDate': !exists(json, 'sampleSignatureDate') ? undefined : (json['sampleSignatureDate'] === null ? null : new Date(json['sampleSignatureDate'])),
        'refusalReason': json['refusalReason'],
        'repairMethod': json['repairMethod'],
        'invoiceNumber': json['invoiceNumber'],
        'invoiceNumberNA': json['invoiceNumberNA'],
        'reasonNotTakingControlSample': json['reasonNotTakingControlSample'],
        'regulations': json['regulations'],
        'regulationIds': json['regulationIds'],
        'additionalInfo': json['additionalInfo'],
        'findings': json['findings'],
        'completionDate': !exists(json, 'completionDate') ? undefined : (json['completionDate'] === null ? null : new Date(json['completionDate'])),
        'witnesses': json['witnesses'],
        'collectDate': !exists(json, 'collectDate') ? undefined : (json['collectDate'] === null ? null : new Date(json['collectDate'])),
        'euProjectTypeId': json['euProjectTypeId'],
    };
}

export function CreateUpdateSampleExamDtoToJSON(value?: CreateUpdateSampleExamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sampleCollectId': value.sampleCollectId,
        'protocolNumber': value.protocolNumber,
        'sysNumber': value.sysNumber,
        'fileNumber': value.fileNumber,
        'technicalSpecification': value.technicalSpecification,
        'organizationTypeId': value.organizationTypeId,
        'protocolPrintModeId': value.protocolPrintModeId,
        'comments': value.comments,
        'approved': value.approved,
        'projectPOIiS': value.projectPOIiS,
        'productTypeId': value.productTypeId,
        'securedQuantity': value.securedQuantity,
        'expirationDate': value.expirationDate === undefined ? undefined : (value.expirationDate === null ? null : value.expirationDate.toISOString()),
        'expirationText': value.expirationText,
        'expirationNA': value.expirationNA,
        'supplyDate': value.supplyDate === undefined ? undefined : (value.supplyDate === null ? null : value.supplyDate.toISOString()),
        'supplierId': value.supplierId,
        'supplierNA': value.supplierNA,
        'supplierUnknown': value.supplierUnknown,
        'sampleSignatureDate': value.sampleSignatureDate === undefined ? undefined : (value.sampleSignatureDate === null ? null : value.sampleSignatureDate.toISOString()),
        'refusalReason': value.refusalReason,
        'repairMethod': value.repairMethod,
        'invoiceNumber': value.invoiceNumber,
        'invoiceNumberNA': value.invoiceNumberNA,
        'reasonNotTakingControlSample': value.reasonNotTakingControlSample,
        'regulations': value.regulations,
        'regulationIds': value.regulationIds,
        'additionalInfo': value.additionalInfo,
        'findings': value.findings,
        'completionDate': value.completionDate === undefined ? undefined : (value.completionDate === null ? null : value.completionDate.toISOString()),
        'witnesses': value.witnesses,
        'collectDate': value.collectDate === undefined ? undefined : (value.collectDate === null ? null : value.collectDate.toISOString()),
        'euProjectTypeId': value.euProjectTypeId,
    };
}


